import { Offence } from 'utils/types';
import { AxiosResponse } from 'axios';
import { axiosInstance } from 'hooks/auth/AxiosInstance';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
const fetchData = async (id: string): Promise<Offence> => {
  try {
    const response: AxiosResponse<Offence> = await axiosInstance.get(
      `offence/${id}`,
    );
    return response.data;
  } catch (error) {
    if (error instanceof Error) {
      throw new Error(error.message);
    } else {
      throw new Error('An uknown error occured');
    }
  }
};

const useGetSingleOffence = (id: string): UseQueryResult<Offence, Error> => {
  return useQuery<Offence, Error>({
    queryKey: ['offence', id],
    queryFn: () => fetchData(id),
    refetchInterval: 2000,
    refetchOnWindowFocus: false,
    staleTime: 0,
  });
};

export default useGetSingleOffence;
